/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SearchClientLibraryClientIdGet$Params {
  clientId: string;
}

export function searchClientLibraryClientIdGet(http: HttpClient, rootUrl: string, params: SearchClientLibraryClientIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, searchClientLibraryClientIdGet.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MediaStrictHttpResponse<void>;
    })
  );
}

searchClientLibraryClientIdGet.PATH = '/Search/ClientLibrary/{clientId}';
